/**
 * The "Make it Count" wordmark — Libre Baskerville with italic
 * coral-deep emphasis on "Count", per STYLE_GUIDE.md §3.1.
 *
 * Extracted into its own component so it can be used both in the
 * top bar (small, 17px) and in the sign-in hero (larger). The `size`
 * prop controls the typography scale; everything else is fixed.
 */

interface Props {
  size?: "small" | "hero" | undefined;
  className?: string | undefined;
}

export function Wordmark({ size = "small", className: extraClass }: Props) {
  const baseClass =
    size === "hero"
      ? "font-serif text-display-md text-ink"
      : "font-serif text-[17px] tracking-[0.01em] text-ink";

  return (
    <span className={`${baseClass} ${extraClass ?? ""}`}>
      Make it{" "}
      <em className="italic font-normal text-coral-deep">Count</em>
    </span>
  );
}
